export default {
  salesMaximizerTagLabelSuccess: {
    id: 'bo_seller.listings.listings_table.sales_maximizer_maximizing_sales_tag_label',
    defaultMessage: "You're maximizing sales",
  },
  salesMaximizerTagLabelAvailable: {
    id: 'bo_seller.listings.listings_table.sales_maximizer_available_tag_label',
    defaultMessage: 'Sales maximizer opportunity',
  },
  estimatedSales: {
    id: 'bo_seller.listings.listings_table.sales_maximizer_estimated_sales',
    defaultMessage: 'Estimated sales: {units} units',
  },
  dealOpportunityLabel: {
    id: 'bo_seller.listings.listings_table.pricing_strategy.deal.opportunity_label',
    defaultMessage: 'Deal opportunity',
  },
  gotTheDealLabel: {
    id: 'bo_seller.listings.listings_table.pricing_strategy.deal.got_the_deal_label',
    defaultMessage: "You've got the deal",
  },
  saveUpToCommissionRateLabel: {
    id: 'bo_seller.listings.listings_table.pricing_strategy.deal.save_up_to_commission_rate_label',
    defaultMessage: 'Save up to {percentage}% on commission rate',
  },
  commissionRateIsUpToLessLabel: {
    id: 'bo_seller.listings.listings_table.commission_rate_is_up_to_less_label',
    defaultMessage: 'Commision rate is up to {percentage}% less',
  },
  almostThereLabel: {
    id: 'bo_seller.listings.listings_table.pricing_strategy.deal.almost_there_label',
    defaultMessage: 'Almost there! Win BackBox to sell and Save',
  },
  orLessLabel: {
    id: 'bo_seller.listings.listings_table.pricing_strategy.deal.or_less_label',
    defaultMessage: '{price} or less',
  },
}
